import $ from 'jquery'
import 'sticky-kit/dist/sticky-kit'
import jcf from 'jcf'
import { pathOr } from 'ramda'
import Cookies from 'js-cookie'

const customLabel = pathOr({ active: 'Activés', disabled: 'Désactivés' }, ['drupalSettings', 'widgets', 'personalData', 'customLabel'], window)
const cookieDomain = pathOr('', ['drupalSettings', 'adagio', 'cookieconsentdomain'], window)
export const renderPersonalData = (
  wrapper = document.querySelector('.personal-data'),
) => {
  const holder = $(wrapper)
  const personaldataCloseLink = holder.find('.cards-banner-widget__float-nav')
  const personaldataLink = holder.find('.destintation__main-nav .destintation-filter-widget a')
  const stickyMenu = holder.find('.menu-title ul, .destintation__main-nav .destintation-filter-widget ul, .cards-banner-widget__float-nav')
  const stickyMenuItem = holder.find('.menu-title ul li, .destintation__main-nav .destintation-filter-widget ul li')
  const checkboxes = $('.personal-data').find('input[class*="form-checkbox"]')
  const button = holder.find('.form-checkbox-btn')
  const cookieName = 'cookieconsent'
  let cookieVal = Cookies.get(cookieName)
  if (cookieVal === 'true' || cookieVal === 'tmp') cookieVal = 1

  const chbValUpdate = () => {
    $.each(checkboxes, (key) => {
      const val = $(checkboxes[key]).val()
      $(checkboxes[key]).prop({
        checked: cookieVal && val >= cookieVal,
        disabled: cookieVal && val > cookieVal,
      })
      $(checkboxes[key]).parents('label').find('span.checkbox-label').text(customLabel[cookieVal && val >= cookieVal ? 'active' : 'disabled'])
      jcf.refresh($(checkboxes[key]))
    })
  }

  chbValUpdate()

  checkboxes.on('change', (e) => {
    if ($(e.target).is(':checked')) {
      cookieVal = $(e.target).val()
    } else {
      const nextVal = parseInt($(e.target).val(), 10) + 1
      cookieVal = nextVal > 3 ? false : nextVal
    }
    chbValUpdate()
  })

  button.on('click', () => {
    Cookies.set(cookieName, cookieVal, { path: '/', domain: cookieDomain })
  })

  jcf.replace('.form-checkbox', 'Checkbox', {})

  stickyMenuItem.each(() => {
    const link = stickyMenuItem.find('a')
    link.on('click', function () {
      $(wrapper).find('.menu-title ul li a, .destintation__main-nav .destintation-filter-widget ul li a').removeClass('active')
      $(this).addClass('active')
    })
  })

  personaldataCloseLink.on('click', (e) => {
    e.preventDefault()
    $('.destintation__main-nav, .menu-btn').toggleClass('active')
  })
  personaldataLink.on('click', () => {
    if (window.innerWidth < 768) {
      $('.destintation__main-nav, .menu-btn').toggleClass('active')
    }
  })

  function resizeHandler() {
    const headerHeight = $('.site-header').outerHeight() - $('.site-header__pre-header').outerHeight() + 4
    const cookieHeight = $('.cookie-banner-wrapper').outerHeight()
    let stickyOffset = headerHeight + cookieHeight + 20

    if (window.innerWidth < 768) {
      stickyOffset = headerHeight + cookieHeight + 9
    }

    stickyMenu.trigger('sticky_kit:detach')
    stickyMenu.stick_in_parent({
      offset_top: stickyOffset,
    })
  }
  $('.cookie-banner').find('.btn-close , .btn-holder a').on('click', () => {
    resizeHandler()
  })
  $(window).on('resize', resizeHandler)
}
